import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Links from '@mui/material/Link';

import { useLocalStorage } from "../components/useLocalStorage";
import { Outlet, Link } from "react-router-dom";
import { useState } from "react";

const TextFieldStyle = { width: '100%' };

const AppBoardScreen = () => {

    const [CambioDeNombre, setCambioDeNombre] = useLocalStorage("CambioDeNombre", "");
    const [RenovaciónDePlacas, setRenovaciónDePlacas] = useLocalStorage("RenovaciónDePlacas", "");
    const [ReemplazoDeRegistración, setReemplazoDeRegistración] = useLocalStorage("ReemplazoDeRegistración", "");
    const [ReporteDeVenta, setReporteDeVenta] = useLocalStorage("ReporteDeVenta", "");

    const [buttonStatus, setButtonStatus] = useState(false);  
    const inputChangeHandler = () => {
        setTimeout(() => {
            if (RenovaciónDePlacas.length > 0 && CambioDeNombre.length > 0 && ReemplazoDeRegistración.length > 0 && ReporteDeVenta.length > 0) {
                setButtonStatus(true);
            } else {
                setButtonStatus(false);
            }    
        }, 100)
    };

    inputChangeHandler();

    return (
        <Box id="AppBoardScreen1" className="AppBoardScreen AppBoardScreen1" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12}>
                    <h2 className="subHeading">¿Con qué tipo de servicio lo podemos ayudar el día de hoy? ¿Que servicio necesita el día de hoy?</h2>
                </Grid>
                <Grid item xs={12}>
                    <TextField onKeyUp={inputChangeHandler} onChange={(e) => setRenovaciónDePlacas(e.target.value)} value={RenovaciónDePlacas} label="Renovación de placas" variant="outlined" sx={TextFieldStyle} />
                </Grid>
                <Grid item xs={12}>
                    <Tooltip title="Pagar tarifas anuales del DMV para un vehículo Pregunta Clave: ¿Quiere obtener el sticker anual que va en la esquina de la placa?" placement="top">
                        <TextField onKeyUp={inputChangeHandler} onChange={(e) => setCambioDeNombre(e.target.value)} value={CambioDeNombre} label="Cambio de nombre" variant="outlined" sx={TextFieldStyle} />
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    <TextField onKeyUp={inputChangeHandler} onChange={(e) => setReemplazoDeRegistración(e.target.value)} value={ReemplazoDeRegistración} label="Reemplazo de registración" variant="outlined" sx={TextFieldStyle} />
                </Grid>
                <Grid item xs={12}>
                    <TextField onKeyUp={inputChangeHandler} onChange={(e) => setReporteDeVenta(e.target.value)} value={ReporteDeVenta} label="Reporte de venta" variant="outlined" sx={TextFieldStyle} />
                </Grid>
                <Grid item xs={12}>
                    <Links href="https://www.aseguranzadeauto.com/broker-logins/" target="_blank" rel="noreferrer" underline="always">{'Insurance'}</Links>
                </Grid>

                <Grid item xs={6} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/">
                        <Button className="PrevButton" variant="outlined" size="large">Previa</Button>
                    </Link>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <Link to="/dmv/cambio/RegistrationRequireInfo">
                        <Button disabled={!buttonStatus} className="NextButton" variant="contained" size="large">Próxima</Button>
                    </Link>
                </Grid>
                <Outlet />

            </Grid>
        </Box>
    );
};

export default AppBoardScreen;